import SansthaManagerContainer from "../../container/admin/sanstha-manager";

const SansthaManager = () => {
    return <SansthaManagerContainer />;
};

export default SansthaManager;